import React, { useState } from 'react';
import { registerUser, loginUser } from '../services/auth';

const Auth = ({ onAuthSuccess }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [shopDomain, setShopDomain] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const getErrorMessage = (error) => {
    console.log('Code erreur:', error.code);
    switch (error.code) {
      case 'auth/email-already-in-use':
        return 'Cette adresse email est déjà utilisée';
      case 'auth/invalid-email':
        return 'Adresse email invalide';
      case 'auth/operation-not-allowed':
        return 'La connexion par email/mot de passe n\'est pas activée';
      case 'auth/weak-password':
        return 'Le mot de passe doit contenir au moins 6 caractères';
      case 'auth/user-disabled':
        return 'Ce compte a été désactivé';
      case 'auth/user-not-found':
      case 'auth/wrong-password':
        return 'Email ou mot de passe incorrect';
      case 'auth/invalid-credential':
        return 'Email ou mot de passe incorrect';
      default:
        return `Une erreur est survenue: ${error.message}`;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      let user;
      if (isLogin) {
        console.log('Tentative de connexion avec:', email);
        user = await loginUser(email, password);
        console.log('Utilisateur connecté:', user);
      } else {
        console.log('Tentative d\'inscription avec:', email);
        let shopNameToUse = shopDomain;
        
        // Vérifier si shopDomain est un objet et extraire le domaine si nécessaire
        if (shopDomain && typeof shopDomain === 'object' && shopDomain.domain) {
          shopNameToUse = shopDomain.domain;
        }
        
        const shopData = {
          domain: shopDomain,
          accessToken: '' // À obtenir via OAuth Shopify
        };
        
        // Utiliser shopNameToUse (chaîne de caractères) au lieu de shopData (objet)
        user = await registerUser(email, password, shopNameToUse);
        console.log('Utilisateur inscrit:', user);
      }
      
      if (user) {
        console.log('Authentification réussie, appel de onAuthSuccess');
        onAuthSuccess(user);
      } else {
        console.error('Utilisateur null après authentification');
        setError('Erreur d\'authentification');
      }
    } catch (error) {
      console.error('Erreur d\'authentification:', error);
      setError(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{isLogin ? 'Connexion' : 'Inscription'}</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              minLength="6"
            />
          </div>
          
          {!isLogin && (
            <div className="form-group">
              <label>Domaine Shopify</label>
              <input
                type="text"
                value={shopDomain}
                onChange={(e) => setShopDomain(e.target.value)}
                placeholder="votre-boutique.myshopify.com"
                required={!isLogin}
                disabled={loading}
              />
            </div>
          )}
          
          <button 
            type="submit" 
            className="button-primary"
            disabled={loading}
          >
            {loading ? 'Chargement...' : (isLogin ? 'Se connecter' : 'S\'inscrire')}
          </button>
        </form>
        
        <div className="auth-toggle">
          <button 
            onClick={() => {
              setIsLogin(!isLogin);
              setError('');
            }}
            className="button-link"
            disabled={loading}
          >
            {isLogin ? 'Créer un compte' : 'Déjà un compte ?'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Auth;
